import React from 'react';

import classNames from 'classnames';
import ChevronDownIcon from 'icons/chevron-down.svg';
import ChevronUpIcon from 'icons/chevron-up.svg';
import PersonIcon from 'icons/person.svg';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import OptionChoice from 'components/application/OptionChoice';
import Options from 'components/application/Options';
import Tooltip from 'components/application/Tooltip';

export default function SelectedTeamEditor({ onChange, teamSelection }) {
  const { t: i18nTCommon } = useTranslation('common');

  return (
    <Options
      btnToggle={(isOpen) => (
        <div className='tooltip-parent tw-h-6'>
          <OutlinedButton className='tw-h-6' color='white' onClick={() => {}}>
            {teamSelection.isManager && <PersonIcon height={20} width={20} />}
            <span className='tw-pr-1 tw-text-s'>
              {teamSelection.isManager ?
                i18nTCommon('shared.manager')
              : i18nTCommon('shared.member')}
            </span>
            <ChevronUpIcon
              className='-tw-mr-2'
              height={24}
              style={{ display: isOpen ? 'inline-block' : 'none' }}
              width={24}
            />
            <ChevronDownIcon
              className={classNames(
                '-tw-mr-2',
                !teamSelection.isStatusChangeEnabled &&
                  '[&_polygon]:tw-fill-grey-300',
              )}
              height={24}
              style={{ display: isOpen ? 'none' : 'inline-block' }}
              width={24}
            />
          </OutlinedButton>
          {!teamSelection.isStatusChangeEnabled && (
            <Tooltip
              placement='top'
              tooltip={teamSelection.tooltip}
              trigger='hover'
            />
          )}
        </div>
      )}
      buttonDisabled={!teamSelection.isStatusChangeEnabled}
      key='memberStatus'
      listStyle='[&_li]:tw-h-auto'
      toggleStyle='[&_.options__toggle]:tw-h-6'
    >
      <OptionChoice
        onClick={(setOptionsOpen) => {
          onChange({ teamSelection, isManager: false });
          setOptionsOpen(false);
        }}
      >
        <div className='tw-flex tw-flex-col tw-px-3 tw-py-2.5'>
          <span className='tw-text-m tw-text-grey-700'>
            {i18nTCommon('shared.member')}
          </span>
          <span className='tw-text-s tw-text-grey-500'>
            {i18nTCommon('teams.noViewOrEditAccess')}
          </span>
        </div>
      </OptionChoice>
      <OptionChoice
        onClick={(setOptionsOpen) => {
          onChange({ teamSelection, isManager: true });
          setOptionsOpen(false);
        }}
      >
        <div className='tw-flex tw-flex-col tw-px-3 tw-py-2.5'>
          <span className='tw-text-m tw-text-grey-700'>
            {i18nTCommon('shared.manager')}
          </span>
          <span className='tw-text-s tw-text-grey-500'>
            {i18nTCommon('teams.canEditMembersAlreadyInTeam')}
          </span>
        </div>
      </OptionChoice>
      <div className='tw-cursor-default tw-text-wrap tw-border-t-grey-100 tw-bg-grey-025 tw-px-2.5 tw-py-3 tw-text-s tw-text-grey-500'>
        <Trans
          components={{
            a: (
              /* eslint-disable jsx-a11y/anchor-has-content */
              <a
                className='tw-inline tw-w-0 tw-p-0'
                href='https://intercom.help/hands-hq/en/articles/9158540-how-to-create-and-manage-teams'
                rel='noreferrer'
                target='_blank'
              />
              /* eslint-enable jsx-a11y/anchor-has-content */
            ),
          }}
          i18nKey='teams.onlyUsersWithEditorPermissionCanAddMembers'
          ns='common'
        />
      </div>
    </Options>
  );
}

SelectedTeamEditor.propTypes = {
  teamSelection: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
